module.exports = new __parcel__URL__("Angie.54f8d1c9.svg").toString();